// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.cesium-cesiumInspector-statistics {
  margin: 0;
  padding-top: 3px;
  padding-bottom: 3px;
}

ul.cesium-cesiumInspector-statistics + ul.cesium-cesiumInspector-statistics {
  border-top: 1px solid #aaa;
}

.cesium-cesiumInspector-slider {
  margin-top: 5px;
}

.cesium-cesiumInspector-slider input[type="number"] {
  text-align: left;
  background-color: #222;
  outline: none;
  border: 1px solid #444;
  color: #edffff;
  width: 100px;
  border-radius: 3px;
  padding: 1px;
  margin-left: 10px;
  cursor: auto;
}

.cesium-cesiumInspector-slider input[type="number"]::-webkit-outer-spin-button,
.cesium-cesiumInspector-slider input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.cesium-cesiumInspector-slider input[type="range"] {
  margin-left: 5px;
  vertical-align: middle;
}

.cesium-cesiumInspector-hide .cesium-cesiumInspector-styleEditor {
  display: none;
}

.cesium-cesiumInspector-styleEditor {
  padding: 10px;
  border-radius: 5px;
  background: rgba(48, 51, 54, 0.8);
  border: 1px solid #444;
}

.cesium-cesiumInspector-styleEditor textarea {
  width: 100%;
  height: 300px;
  background: transparent;
  color: #edffff;
  border: none;
  padding: 0;
  white-space: pre;
  overflow-wrap: normal;
  overflow-x: auto;
}

.cesium-3DTilesInspector {
  width: 300px;
  pointer-events: all;
}

.cesium-3DTilesInspector-statistics {
  font-size: 11px;
}

.cesium-3DTilesInspector-disabledElementsInfo {
  margin: 5px 0 0 0;
  padding: 0 0 0 20px;
  color: #eed202;
}

.cesium-3DTilesInspector div,
.cesium-3DTilesInspector input[type="range"] {
  width: 100%;
  box-sizing: border-box;
}

.cesium-cesiumInspector-error {
  color: #ff9e9e;
  overflow: auto;
}

.cesium-3DTilesInspector .cesium-cesiumInspector-section {
  margin-top: 3px;
}

.cesium-3DTilesInspector
  .cesium-cesiumInspector-sectionHeader
  + .cesium-cesiumInspector-show {
  border-top: 1px solid white;
}

input.cesium-cesiumInspector-url {
  overflow: hidden;
  white-space: nowrap;
  overflow-x: scroll;
  background-color: transparent;
  color: white;
  outline: none;
  border: none;
  height: 1em;
  width: 100%;
}

.cesium-cesiumInspector .field-group {
  display: table;
}

.cesium-cesiumInspector .field-group > label {
  display: table-cell;
  font-weight: bold;
}

.cesium-cesiumInspector .field-group > .field {
  display: table-cell;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/Cesium3DTilesInspector/Cesium3DTilesInspector.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":["ul.cesium-cesiumInspector-statistics {\n  margin: 0;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n\nul.cesium-cesiumInspector-statistics + ul.cesium-cesiumInspector-statistics {\n  border-top: 1px solid #aaa;\n}\n\n.cesium-cesiumInspector-slider {\n  margin-top: 5px;\n}\n\n.cesium-cesiumInspector-slider input[type=\"number\"] {\n  text-align: left;\n  background-color: #222;\n  outline: none;\n  border: 1px solid #444;\n  color: #edffff;\n  width: 100px;\n  border-radius: 3px;\n  padding: 1px;\n  margin-left: 10px;\n  cursor: auto;\n}\n\n.cesium-cesiumInspector-slider input[type=\"number\"]::-webkit-outer-spin-button,\n.cesium-cesiumInspector-slider input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.cesium-cesiumInspector-slider input[type=\"range\"] {\n  margin-left: 5px;\n  vertical-align: middle;\n}\n\n.cesium-cesiumInspector-hide .cesium-cesiumInspector-styleEditor {\n  display: none;\n}\n\n.cesium-cesiumInspector-styleEditor {\n  padding: 10px;\n  border-radius: 5px;\n  background: rgba(48, 51, 54, 0.8);\n  border: 1px solid #444;\n}\n\n.cesium-cesiumInspector-styleEditor textarea {\n  width: 100%;\n  height: 300px;\n  background: transparent;\n  color: #edffff;\n  border: none;\n  padding: 0;\n  white-space: pre;\n  overflow-wrap: normal;\n  overflow-x: auto;\n}\n\n.cesium-3DTilesInspector {\n  width: 300px;\n  pointer-events: all;\n}\n\n.cesium-3DTilesInspector-statistics {\n  font-size: 11px;\n}\n\n.cesium-3DTilesInspector-disabledElementsInfo {\n  margin: 5px 0 0 0;\n  padding: 0 0 0 20px;\n  color: #eed202;\n}\n\n.cesium-3DTilesInspector div,\n.cesium-3DTilesInspector input[type=\"range\"] {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cesium-cesiumInspector-error {\n  color: #ff9e9e;\n  overflow: auto;\n}\n\n.cesium-3DTilesInspector .cesium-cesiumInspector-section {\n  margin-top: 3px;\n}\n\n.cesium-3DTilesInspector\n  .cesium-cesiumInspector-sectionHeader\n  + .cesium-cesiumInspector-show {\n  border-top: 1px solid white;\n}\n\ninput.cesium-cesiumInspector-url {\n  overflow: hidden;\n  white-space: nowrap;\n  overflow-x: scroll;\n  background-color: transparent;\n  color: white;\n  outline: none;\n  border: none;\n  height: 1em;\n  width: 100%;\n}\n\n.cesium-cesiumInspector .field-group {\n  display: table;\n}\n\n.cesium-cesiumInspector .field-group > label {\n  display: table-cell;\n  font-weight: bold;\n}\n\n.cesium-cesiumInspector .field-group > .field {\n  display: table-cell;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
